[
  {
    "released_at": "2026-07-30",
    "title": "Improved connection health reporting",
    "tags": [
      "observability",
      "Auth"
    ],
    "description": "Connections are now marked unhealthy only when a provider no longer accepts their credentials or access. Unhealthy connection notifications now include provider HTTP status information when available. Validation errors, missing records, rate limits, and temporary provider outages no longer affect connection health."
  },
  {
    "released_at": "2026-01-30",
    "title": "Enhancement: Clickhouse external logging",
    "tags": [
      "observability"
    ],
    "description": "Send detailed API logs to your Clickhouse account"
  },
  {
    "released_at": "2026-01-30",
    "title": "Enhancement: Grafana external logging",
    "tags": [
      "observability"
    ],
    "description": "Send detailed API logs to your Grafana account"
  },
  {
    "released_at": "2026-01-29",
    "title": "Enhancement: HashiCorp Vault",
    "tags": [
      "security"
    ],
    "description": "Store API credentials in your HashiCorp Vault"
  },
  {
    "released_at": "2026-01-29",
    "title": "Enhancement: Google Cloud Secrets Manager",
    "tags": [
      "security"
    ],
    "description": "Store API credentials in your Google Cloud Secrets Manager"
  },
  {
    "released_at": "2026-01-29",
    "title": "Enhancement: Azure Key Vault",
    "tags": [
      "security"
    ],
    "description": "Store API credentials in your Azure Key Vault"
  },
  {
    "released_at": "2026-01-26",
    "title": "Enhancement: AWS Secrets Manager",
    "tags": [
      "security"
    ],
    "description": "Store API credentials in your AWS Secrets Manager account"
  },
  {
    "released_at": "2026-01-26",
    "title": "Enhancement: JumpCloud SAML",
    "tags": [
      "security"
    ],
    "description": "Sign-in using your JumpCloud SAML"
  },
  {
    "released_at": "2026-01-26",
    "title": "Enhancement: Google SAML",
    "tags": [
      "security"
    ],
    "description": "Sign-in using your Google Workspace Directory SAML"
  },
  {
    "released_at": "2026-01-26",
    "title": "Enhancement: Microsoft Entra SAML",
    "tags": [
      "security"
    ],
    "description": "Sign-in using your Microsoft Entra SAML"
  },
  {
    "released_at": "2026-01-26",
    "title": "Enhancement: Okta SAML ",
    "tags": [
      "security"
    ],
    "description": "Sign-in using your Okta SAML"
  },
  {
    "released_at": "2025-10-20",
    "title": "MCP Server now supports workspace-only authorization",
    "tags": [
      "MCP"
    ],
    "description": "This new mode allows our customer's developer to access their connection metadata, webhook, logs and support tickets from an LLM"
  },
  {
    "released_at": "2025-10-13",
    "title": "date parsing was enhanced to ensure that all dates are returned as ISO format",
    "tags": [],
    "description": ""
  },
  {
    "released_at": "2025-08-22",
    "title": "Unified MCP server now supports 100% of an integration's available API endpoints",
    "tags": [
      "MCP"
    ],
    "description": ""
  },
  {
    "released_at": "2025-08-22",
    "title": "Unified MCP server is now available in our European data-region",
    "tags": [
      "MCP",
      "Data Center"
    ],
    "description": ""
  },
  {
    "released_at": "2025-07-18",
    "title": "Unified MCP server now supports Tools structured natively for Cohere",
    "tags": [
      "MCP"
    ],
    "description": ""
  },
  {
    "released_at": "2025-07-18",
    "title": "Unified MCP server now supports aliases to expand tools",
    "tags": [
      "MCP"
    ],
    "description": ""
  },
  {
    "released_at": "2025-07-11",
    "title": "Unified MCP server can now return Tools structured natively for OpenAI and Gemini",
    "tags": [
      "MCP"
    ],
    "description": ""
  },
  {
    "released_at": "2025-07-11",
    "title": "New option to hide sensitive data in Unified MCP server",
    "tags": [
      "MCP"
    ],
    "description": " Added hide_sensitive parameter to remove PII/sensitive data from results"
  },
  {
    "released_at": "2025-07-11",
    "title": "New permissions parameter for Unified MCP server",
    "tags": [
      "MCP"
    ],
    "description": "New permissions parameter to restrict available tools"
  },
  {
    "released_at": "2025-07-11",
    "title": "\nAdded additional authentication method in Unified MCP server ",
    "tags": [
      "MCP"
    ],
    "description": "New authentication uses workspace API keys for use directly with LLM APIs"
  },
  {
    "released_at": "2025-07-10",
    "title": "Updated Unified MCP server to v2025-06-18",
    "tags": [
      "MCP"
    ],
    "description": "Major upgrade now returns structuredContent (is. Data)"
  },
  {
    "released_at": "2024-10-29",
    "title": "Introducing Svelte Authorization Component",
    "tags": [
      "Auth"
    ],
    "description": "We're excited to introduce the Svelte Authorization component, adding support for the \"most loved\" front-end framework. Svelte developers can now add our powerful authorization component directly into their applications, joining our existing support for React, Angular, and Vue."
  },
  {
    "released_at": "2024-10-10",
    "title": "Expanded Support for Response Formats",
    "tags": [
      "API"
    ],
    "description": "We're excited to announce that [Unified.to](https://unified.to/) now supports multiple response formats for our unified API, giving you even more flexibility in how you receive and process data from our endpoints. In addition to JSON (our default), you can now opt for CSV, XML, SCIM+JSON (HRIS endpoints), and NDJSON (Newline Delimited JSON for AI data storage). These new formats are designed to fit your specific use cases and data processing workflows."
  },
  {
    "released_at": "2024-10-03",
    "title": "New Category: Unified SCIM API",
    "tags": [
      "SCIM"
    ],
    "description": "We've launched a unified System for Cross-domain Identity Management (SCIM) API to simplify user provisioning across multiple integrations. Our SCIM API allows you to seamlessly manage user identities, groups, and attributes across over 100 integrations, even for providers that don't natively support SCIM. Any integration that supports the Employee object will now support our new SCIM endpoints as well."
  },
  {
    "released_at": "2024-04-19",
    "title": "New Event Notifications",
    "tags": [
      "Settings"
    ],
    "description": "We're excited to announce event notifications, making staying informed about your account event activity easy. This feature allows you to instantly notify an end-user if their connection is unhealthy, usually indicating a need for re-authentication, and to ensure visibility into your account's usage to avoid unexpected overages. You can also use notifications to link an end user's connection to their specific record by listening to the connection_created event and referring to the external_xref field. Go to Settings > Workspace to insert a Webhook Notifications URL and select the events you want to track. You can receive notifications for the following events: connection_created, connection_deleted, connection_healthy, connection_paused, connection_unhealthy, connection_unpaused, connection_updated, integration_activated, integration_deactivated, integration_updated, user_created, user_deleted, webhook_created, webhook_deleted, workspace_80percent_limit, workspace_over_limit, and workspace_updated."
  },
  {
    "released_at": "2024-04-03",
    "title": "New HR Objects: Payslip",
    "tags": [
      "HRIS"
    ],
    "description": "We've introduced the Payslip object to our unified HR API, which allows for tracking employee payslips. Access your customers' payslip data from your HR integrations, including pay period, paid or unpaid, approval status, and comments. Read our API documentation to learn more. "
  },
  {
    "released_at": "2024-04-03",
    "title": "New HR Object: Time Off",
    "tags": [
      "HRIS"
    ],
    "description": "We've introduced the Time Off object to our unified HR API. This new object simplifies tracking and managing employee time off requests (PTO, vacation). Access your customers' time off data from your HR integrations, including the time off request period, approval status, and any comments or notes associated with the time off request. Read our API documentation to learn more. "
  },
  {
    "released_at": "2024-03-11",
    "title": "Virtual webhook support for 70+ integrations",
    "tags": [
      "Webhooks"
    ],
    "description": "We're excited to share that we've released virtual webhook support for 70+ of our pre-built integrations. Unified.to will monitor your customer connections for updates to data objects and notify your webhook URL of those changes. Unified.to handles polling, rate-limiting, and state management. You can subscribe to and manage virtual webhooks exactly how you would with native webhooks. We'd also made it easy to choose between native and virtual objects for individual objects. Click the \"Feature Support\" tab when activating an integration to see which webhook types are supported. Native webhooks can be helpful for real-time updates and support for \"deleted\" events. However, you won't have control over the cost and few integrations support them. Use Unified.to's virtual webhooks for near real-time updates (min. 1 min) and complete control over the cost (choose any frequency interval; webhooks count towards your total monthly API requests). Tailor your webhook strategy to your preferences! "
  },
  {
    "released_at": "2024-03-11",
    "title": "Support Tickets",
    "tags": [
      "Support"
    ],
    "description": "We've made it easier to track support requests related to your integrations. Once logged in to your Unified.to account, navigate to Help > Support Tickets to see a log of your support tickets and the current status. "
  },
  {
    "released_at": "2024-03-11",
    "title": "New Category: Unified Payment API (beta)",
    "tags": [
      "Payment"
    ],
    "description": "We've launched a unified Payment API to give next-generation fintech and e-commerce companies simplified and secure access to their customers' payment accounts. You can integrate with your customers' payment accounts to seamlessly access payment data, including refunds, payouts, and payment links. Our Payment API includes pre-built integrations for Stripe, QuickBooks, Xero, and Zoho Book"
  },
  {
    "released_at": "2024-02-07",
    "title": "Webhooks: Maximum Page Size",
    "tags": [
      "Webhooks"
    ],
    "description": "We've improved webhooks, allowing you to set a maximum page size (page_max_limit) for better control over payload sizes. This feature helps manage large default page sizes, ensuring more efficient data transmission to your servers. You can also specify which fields to include for more precise control."
  },
  {
    "released_at": "2024-02-07",
    "title": "New ATS Object: Company",
    "tags": [
      "ATS"
    ],
    "description": "We've introduced Company support within our unified ATS API. Now, Jobs and Candidates can be seamlessly associated with a Company. This addition is particularly valuable for ATS providers that serve agencies managing multiple clients. Our JobAdder integration fully supports the Company feature, and we plan to expand this feature to other ATS integrations."
  },
  {
    "released_at": "2024-02-07",
    "title": "New Category: Unified Commerce API (beta)",
    "tags": [
      "E-commerce"
    ],
    "description": "We are excited to announce the launch of our unified e-commerce API in beta, providing comprehensive support for products or items, collections of products, inventories, and locations. This powerful addition, combined with our unified Accounting API, empowers e-commerce SaaS companies to seamlessly access relevant customer data. Shopify is our first supported integration in this new category, with more integrations on our roadmap."
  },
  {
    "released_at": "2024-02-07",
    "title": "New Sandbox Environment",
    "tags": [
      "Environments"
    ],
    "description": "To simplify integration testing, we've introduced a new Sandbox environment that allows you to read and write data to any integration. To ensure data accuracy, we'll always return data in the format that the integration supports. Our Sandbox environment is best to use when you do not have a test account with the third-party platform or a live customer using your integration. When you activate an integration in your [Unified.to](https://unified.to/) account, we'll automatically provision a Sandbox environment."
  },
  {
    "released_at": "2024-01-10",
    "title": "Enhancements: Webhooks",
    "tags": [
      "Webhooks"
    ],
    "description": "We've introduced a major update to our webhooks for easier historical data retrieval, improved webhook observability, and enhanced control over the data you access. Visit our blog or API documentation for more details. "
  },
  {
    "released_at": "2024-01-03",
    "title": "New Category: Unified Storage API",
    "tags": [
      "Storage"
    ],
    "description": "We've introduced a unified storage API with pre-built integrations for Google Drive, Dropbox, Box, Amazon S3, SharePoint, and OneDrive. Enhance your app functionality with access to your customers' third-party file and folder data."
  },
  {
    "released_at": "2023-12-18",
    "title": "Unified Accounting API: Enhancements to Accounts and Transactions",
    "tags": [
      "Accounting"
    ],
    "description": "We've broadened support for Bank Accounts and Bank Transactions. You can now integrate these functionalities with Zoho Books, QuickBooks, and Xero."
  },
  {
    "released_at": "2023-12-18",
    "title": "New Accounting objects: Tax Rate and Organization",
    "tags": [
      "Accounting"
    ],
    "description": "We've enhanced our Accounting API with Tax Rate and Organization objects. With the Tax Rate object, you can seamlessly read tax rates with your product, ensuring accurate financial calculations and compliance. With the Organization object, you can read your customers' business information, including legal name, fiscal year end, currency, and more."
  },
  {
    "released_at": "2023-12-14",
    "title": "New ATS object: Application Status ",
    "tags": [
      "ATS"
    ],
    "description": "We've added support for Application Status across our ATS integrations, which enables you to get a list of application statuses, including the original status for the corresponding ATS alongside our unified status. This update is especially beneficial to our Candidate Assessment customers as they can now display their customers' ATS application statuses and choose the appropriate trigger status to perform assessments and background checks."
  },
  {
    "released_at": "2023-11-22",
    "title": "New UI embed: website integrations directory",
    "tags": [
      "Embeds"
    ],
    "description": "Introducing the latest addition to our low-code UI embeds: website integrations directory. Embed a list of your integrations onto any web page with one line of code — your public website updates automatically whenever you deploy new integrations. Easily customize CSS, click-through URLs, categories, and tabs."
  },
  {
    "released_at": "2023-11-20",
    "title": "New SDKs: Ruby and C#",
    "tags": [
      "SDK"
    ],
    "description": "We've added Ruby and C# (C-Sharp) to our SDKs in addition to Go, PHP, Java, and Python. Our SDKs stay up-to-date automatically with our Unified APIs, ensuring you never miss out on the latest enhancements."
  },
  {
    "released_at": "2023-10-26",
    "title": "Enhanced CRM object: Lead",
    "tags": [
      "CRM"
    ],
    "description": "We've added CRM Object support for Salesforce"
  },
  {
    "released_at": "2023-10-26",
    "title": "Enhanced HR object: Group",
    "tags": [
      "HRIS"
    ],
    "description": "We've added HR Group support for Bullhorn"
  },
  {
    "released_at": "2023-10-26",
    "title": "Enhanced HR object: Job",
    "tags": [
      "HRIS"
    ],
    "description": "We've added HR Job support for Salesforce and Techwolf"
  },
  {
    "released_at": "2023-10-26",
    "title": "Enhanced ATS object: Scorecard",
    "tags": [
      "ATS"
    ],
    "description": "We've added ATS Scorecard support for SmartRecruiters"
  },
  {
    "released_at": "2023-10-26",
    "title": "Enhanced ATS object: Job",
    "tags": [
      "ATS"
    ],
    "description": "We've added ATS Object support for SmartRecruiters"
  },
  {
    "released_at": "2023-10-26",
    "title": "Enhanced ATS object: Interview",
    "tags": [
      "ATS"
    ],
    "description": "We've added ATS Interview support for SmartRecruiters and Zoho Recruit"
  },
  {
    "released_at": "2023-10-26",
    "title": "Enhanced ATS object: Application",
    "tags": [
      "ATS"
    ],
    "description": "We've added ATS Application support for Lever, Zoho Recruit, Greenhouse (Ingest), Greenhouse (Harvest), Teamtailor, and SmartRecruiters"
  },
  {
    "released_at": "2023-10-26",
    "title": "New ATS object: Document",
    "tags": [
      "ATS"
    ],
    "description": "We've added support for Document across our ATS integrations, which enables you to store candidate resumes, cover letters, background checks, and other assessment documents from an ATS. Document support is currently available for Greenhouse, Lever, and SmartRecruiters, with additional ATS integrations set to receive the update in the near future."
  },
  {
    "released_at": "2023-09-18",
    "title": "New SDKs",
    "tags": [
      "SDK",
      "Typescript"
    ],
    "description": "We now have five SDKs: Typescript, Go, PHP, Java, and Python. Our SDKs stay up-to-date automatically with our Unified APIs, ensuring you never miss out on the latest enhancements"
  },
  {
    "released_at": "2023-09-13",
    "title": "Automated testing enhancement",
    "tags": [
      "security",
      "observability"
    ],
    "description": "We've already been monitoring data from integrations in real-time to ensure data quality. Now, we're making further enhancements by tracking new, undocumented data fields. This provides a more accurate representation of integration data than third-party API documentation. We continue to maintain data security by not storing any data—only data shapes are observed. We'll roll this update out to all integrations over time, benefiting your entire integration ecosystem."
  },
  {
    "released_at": "2023-09-13",
    "title": "More detailed error codes",
    "tags": [
      "observability"
    ],
    "description": "We're expanding the detail in our error codes to enhance your Unified API experience. With this update, we're providing you with the complete error message, offering a more informative and precise error handling experience. While some integrations already support this enhancement, we are actively rolling it out to other integrations. If you come across an error response with limited details, please inform us on [Discord ](https://discord.gg/uAYnMPFk9t)or fill out [this form](https://unified.to/contact), and we will promptly add support for that specific integration. In addition, these detailed error logs will now be automatically included in your API logs, ensuring you have access to comprehensive error information at your fingertips."
  },
  {
    "released_at": "2023-09-13",
    "title": "Multi-URL support for integrations",
    "tags": [
      "Integrations",
      "Data Center",
      "Environments"
    ],
    "description": "We've introduced multi-URL support for integrations which allows us to accommodate integrations that feature distinct API and Authorization/Authentication URLs. With this update, when activating an integration within Unified.to, you'll have the flexibility to select the appropriate URL set. For example, you can choose between \"Production\" or \"Sandbox.\" This feature also extends to other integrations that may offer different URL sets tailored to specific data regions (Europe or North America) or environments to ensure seamless integration."
  },
  {
    "released_at": "2023-09-13",
    "title": "Greenhouse: new fields",
    "tags": [
      "ATS",
      "passthrough",
      "Auth"
    ],
    "description": "We've expanded the information you can receive from our Greenhouse integration with the following fields: job.description, job.location, job.update_at, and job.public_job_urls."
  },
  {
    "released_at": "2023-09-13",
    "title": "New ATS field: public_job_urls",
    "tags": [
      "ATS"
    ],
    "description": "We've introduced the public_job_url field to our Unified ATS API. Currently, it's supported for Ashby, Lever, TeamTailor, Workable, and Greenhouse integrations. This enhancement allows you to obtain a public link to the job posting when retrieving Job objects through our Unified API."
  },
  {
    "released_at": "2023-09-11",
    "title": "New API documentation site",
    "tags": [
      "Documentation"
    ],
    "description": "Our new API Documentation has a new clean design plus new features"
  },
  {
    "released_at": "2023-08-21",
    "title": "Factorial: New fields",
    "tags": [
      "ATS",
      "HRIS"
    ],
    "description": "Updated group object; added Read access for manager_ids and is_active"
  },
  {
    "released_at": "2023-08-21",
    "title": "Teamtailor: New field",
    "tags": [
      "ATS",
      "HRIS"
    ],
    "description": "Added job object and Read access for language_locale"
  },
  {
    "released_at": "2023-08-21",
    "title": "Recruiterflow: New field",
    "tags": [
      "ATS",
      "HRIS"
    ],
    "description": "Added job object and Read access for remote"
  },
  {
    "released_at": "2023-08-21",
    "title": "Lever: New field",
    "tags": [
      "ATS"
    ],
    "description": "Added contact object and Read access for address"
  },
  {
    "released_at": "2023-08-21",
    "title": "ActiveCampaign: New objects & fields",
    "tags": [
      "marketing",
      "CRM"
    ],
    "description": "Added a deal object; Read access for amount, currency, stage, and pipeline; Write access for amount and currency. Expanded contact object; Read access for updated_at, company and deal_ids. Expanded list object; read access for updated_at."
  },
  {
    "released_at": "2023-08-21",
    "title": "ZohoRecruit: New objects & fields",
    "tags": [
      "ATS"
    ],
    "description": "Added Job and Candidate Objects. Added Read and Write access for address."
  },
  {
    "released_at": "2023-08-21",
    "title": "JazzHR: New objects",
    "tags": [
      "ATS",
      "HRIS"
    ],
    "description": "Added Employee, Job, Application, and Candidate Objects"
  },
  {
    "released_at": "2023-07-18",
    "title": "European Union data region",
    "tags": [
      "Data Center"
    ],
    "description": "An EU data center is now available. Unified users have the option to choose between the US and EU as the location for processing their customer data. European users can now access a separate instance of Unified via [https://app-eu.unified.to](https://app-eu.unified.to/) and [https://api-eu.unified.to](https://api-eu.unified.to/)."
  },
  {
    "released_at": "2023-06-21",
    "title": "New sandbox environment",
    "tags": [
      "Environments"
    ],
    "description": "We've enhanced our Mock API, now directly accessible in your Workspace. Our Mock API returns mock (or fake) data so developers can see the data model in action. In addition to Production, you also have the option to use a Sandbox environment. Add env=Sandbox query parameter to your API calls to get mock data."
  },
  {
    "released_at": "2023-06-14",
    "title": "Multilingual authorization page",
    "tags": [
      "Auth"
    ],
    "description": "Our authorization experience now auto-detects browser language providing a localized integrations experience for your customers. You also have the option to set the language by using the \"lang\" query parameter in the URL. Available languages include English (en), French (fr), Spanish (es), Portuguese (pt), Italian (it), Simplified Chinese (zh), and Hindi (hi)."
  },
  {
    "released_at": "2023-06-06",
    "title": "New ATS object: Interview Scorecard",
    "tags": [
      "ATS"
    ],
    "description": "We've added the interview scorecard object for our ATS integrations. The interview scorecard provides recruiters and hiring managers with a standardized format for evaluating candidates."
  },
  {
    "released_at": "2023-05-25",
    "title": "New ATS Job fields: remote, departments, employment_type, and language_locale",
    "tags": [
      "ATS",
      "Jobs"
    ],
    "description": "We've added four new important fields to our unified mode for ATS Jobs; remote designates if this job is remote, employment_type designates full-time or part-time, and the language required for the position."
  },
  {
    "released_at": "2023-05-17",
    "title": "New ATS Job fields: addresses and compensation",
    "tags": [
      "ATS",
      "Jobs"
    ],
    "description": "We've added two new important fields to our unified model for ATS Jobs; addresses contains a list of locations for that job and compensation contains a list of salary and other compensation information."
  },
  {
    "released_at": "2023-04-21",
    "title": "New HRIS Employee field: terminated_at",
    "tags": [
      "HRIS",
      "Employees"
    ],
    "description": "A new field (terminated_at) was added to the HRIS Employee object."
  },
  {
    "released_at": "2023-04-11",
    "title": "Typescript SDK",
    "tags": [
      "Typescript",
      "SDK"
    ],
    "description": "Unified.to now has a [Typescript SDK](https://unified.to/help/typescript_sdk_client) to help you better utilize the Unified.to API"
  },
  {
    "released_at": "2023-03-27",
    "title": "Passthrough API",
    "tags": [
      "passthrough"
    ],
    "description": "Unified.to now supports a [passthrough API](https://unified.to/help/passthrough_api_a_new_way_to_connect_with_your_vendors) to access data and endpoints at integrations that Unified.to doesn't support in its Unified APIs."
  },
  {
    "released_at": "2023-03-12",
    "title": "Additional CRM objects: Leads, Users, Files, Pipelines, Teams",
    "tags": [
      "CRM",
      "Leads",
      "Users",
      "Files",
      "Pipelines",
      "Teams"
    ],
    "description": "New full-featured CRM objects were introduced today. Most CRM integrations will be updated over the next week to support these objects."
  },
  {
    "released_at": "2023-03-12",
    "title": "Additional ATS object: documents",
    "tags": [
      "ATS",
      "Documents"
    ],
    "description": "New full-featured ATS document object was introduced today. Most ATS integrations will be updated over the next week to support this object."
  },
  {
    "released_at": "2023-03-10",
    "title": "New HRIS object: Groups",
    "tags": [
      "HRIS",
      "Groups"
    ],
    "description": "Groups are division, departments, teams, or just project groups. They contain employee members."
  },
  {
    "released_at": "2023-02-08",
    "title": "Rate-limiting",
    "tags": [
      "rate-limit"
    ],
    "description": "Unified now returns a HTTP 429 error when a integration returns a rate-limiting error"
  },
  {
    "released_at": "2023-02-02",
    "title": "Work Histories in enrichment Person",
    "tags": [
      "Enrichment",
      "Person"
    ],
    "description": "The Person object in our Enrichment API now support work history"
  },
  {
    "released_at": "2023-01-26",
    "title": "Webhooks for all integrations",
    "tags": [
      "Webhooks"
    ],
    "description": "Unified now supports webhooks even for integration vendors that do not natively support webhooks on their API."
  },
  {
    "released_at": "2023-01-19",
    "title": "AWS Secrets Manager",
    "tags": [
      "security"
    ],
    "description": "Store all of your connections' tokens in your AWS Secrets Manager account and not in the [Unified.to](https://unified.to/) database"
  },
  {
    "released_at": "2023-01-18",
    "title": "API Explorer",
    "tags": [
      "Documentation"
    ],
    "description": "Try out any of the API endpoints on our API Documentation page"
  },
  {
    "released_at": "2023-01-16",
    "title": "IP Address restrictions",
    "tags": [
      "security"
    ],
    "description": "A workspace can specify which IP addresses are allowed to access the Unified API"
  },
  {
    "released_at": "2023-01-14",
    "title": "gRPC Server",
    "tags": [
      "gRPC"
    ],
    "description": "Along with a REST/JSON, Unified.to's API can now be accessed through gRPC"
  },
  {
    "released_at": "2023-01-13",
    "title": "Swagger",
    "tags": [
      "Documentation",
      "Swagger"
    ],
    "description": "All of the Unified.to data models and API endpoints are now available in an OpenAPI specification (i.e. swagger)"
  }
]